export const messages = {
  kk: {
    language: {
      kk: 'ҚАЗ',
      ru: 'РУС',
    },
    common: {
      save: 'Сақтау',
      cancel: 'Болдырмау',
      edit: 'Өзгерту',
      delete: 'Жою',
      add: 'Қосу',
      search: 'Іздеу',
      loading: 'Жүктелуде...',
      all: 'Барлығы',
      back: 'Артқа',
      close: 'Жабу',
      refresh: 'Жаңарту',
      today: 'Бүгін',
      yesterday: 'Кеше',
      touchPad: 'Сан енгізу',
      touchScreen: 'Сенсорлы моноблок',
      touchScreenOn: 'Сенсорлы моноблок қосулы',
      touchScreenOff: 'Сенсорлы моноблок өшірулі',
    },
    nav: {
      admin: 'Басқару панелі',
      openCash: 'Кассаны ашу',
      products: 'Тауарлар',
      barcodes: 'Штрихкодтар',
      priceTags: 'Баға жапсырмалары',
      categories: 'Санаттар',
      suppliers: 'Жеткізушілер',
      catalogMenu: 'Мәзір JSON',
      saleMode: 'Касса режимі',
      paymentTypes: 'Төлем түрлері',
      discounts: 'Жеңілдіктер',
      modifiers: 'Модификаторлар',
      cashiers: 'Кассирлер',
      bonuses: 'Бонустар',
      stock: 'Қойма',
      sales: 'Сатылымдар',
      loans: 'Қарыздар',
      analytics: 'Талдау',
    },
    landing: {
      modes: 'Режимдер',
      blog: 'Блог',
      login: 'Кіру',
      start: 'Бастау',
      openCash: 'Кассаны ашу',
      onlineCash: 'Дүкенге арналған онлайн-касса',
      heroTitle: 'Сатыңыз, қойманы жүргізіңіз және табысты бір терезеден бақылаңыз',
      heroText: 'Sauda — шағын бизнеске арналған қарапайым касса: бірнеше батырмамен сату, қалдықтарды бақылау, жеңілдіктер, қарыздар, бірнеше кассир және түсінікті талдау.',
      register: 'Тіркелу',
      haveAccount: 'Менде аккаунт бар',
      browser: 'Браузерде жұмыс істейді',
      devices: 'Телефон, планшет, компьютер',
      fastStart: '5 минутта бастау',
      featuresTitle: 'Дүкенге қажеттінің бәрі',
      featuresText: 'Күрделі баптаусыз — тіркеліп, бірден сата бересіз',
      modesTitle: 'Кассаның екі режимі',
      modesText: 'Қалай сатуды таңдаңыз және оны админ панелінде кез келген уақытта өзгертіңіз',
      catalog: 'Тауарлар бойынша',
      quick: 'Жылдам сату',
      withStock: 'Қоймамен',
      withoutStock: 'Қоймасыз',
      catalogDescription: 'Қалдықтары бар дүкенге арналған толыққанды касса',
      quickDescription: 'Тауар анықтамалығынсыз бастауға арналған',
      modesNote: 'Тауарларды бірден қосуды қаламайсыз ба — жылдам сатудан бастаңыз, ал қойманы кейін қосыңыз',
      audienceTitle: 'Sauda кімдерге арналған',
      audienceText: 'Жылдамдық пен қарапайымдылық маңызды шағын сауда нүктелеріне',
      miniMarket: 'Шағын маркет',
      cafe: 'Кафе',
      fastFood: 'Фастфуд',
      cornerShop: 'Үй жанындағы дүкен',
      stepsTitle: 'Қалай бастауға болады',
      stepsText: 'Алғашқы сатылымға дейінгі үш қадам',
      stepRegister: 'Тіркеліңіз',
      stepChoose: 'Админ панелінен режимді таңдаңыз',
      stepSell: 'Сатыңыз',
      blogTitle: 'Пайда мен кеңестер',
      blogText: 'Касса, есеп және алғашқы сатылымдар жайлы қысқа мақалалар',
      allArticles: 'Барлық мақалалар',
      read: 'Оқу',
      minutes: 'мин',
      ctaTitle: 'Sauda-ны бүгін қолданып көріңіз',
      ctaText: 'Тіркелуге бірнеше минут кетеді — бірден сата аласыз',
      freeStart: 'Тегін бастау',
      footer: 'шағын бизнеске арналған касса және есеп',
    },
  },
  ru: {
    language: {
      kk: 'ҚАЗ',
      ru: 'РУС',
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
      edit: 'Изменить',
      delete: 'Удалить',
      add: 'Добавить',
      search: 'Поиск',
      loading: 'Загрузка...',
      all: 'Все',
      back: 'Назад',
      close: 'Закрыть',
      refresh: 'Обновить',
      today: 'Сегодня',
      yesterday: 'Вчера',
      touchPad: 'Ввод числа',
      touchScreen: 'Сенсорный моноблок',
      touchScreenOn: 'Сенсорный моноблок включён',
      touchScreenOff: 'Сенсорный моноблок выключен',
    },
    nav: {
      admin: 'Админ-панель',
      openCash: 'Открыть кассу',
      products: 'Товары',
      barcodes: 'Штрихкоды',
      priceTags: 'Ценники',
      categories: 'Категории',
      suppliers: 'Поставщики',
      catalogMenu: 'Меню JSON',
      saleMode: 'Режим кассы',
      paymentTypes: 'Типы оплаты',
      discounts: 'Скидки',
      modifiers: 'Модификаторы',
      cashiers: 'Кассиры',
      bonuses: 'Бонусы',
      stock: 'Склад',
      sales: 'Продажи',
      loans: 'Займы',
      analytics: 'Аналитика',
    },
    landing: {
      modes: 'Режимы',
      blog: 'Блог',
      login: 'Войти',
      start: 'Начать',
      openCash: 'Открыть кассу',
      onlineCash: 'Онлайн-касса для магазина',
      heroTitle: 'Продавайте, ведите склад и смотрите прибыль — в одном окне',
      heroText: 'Sauda — простая касса для небольшого бизнеса: продажи за пару кликов, остатки под контролем, скидки, долги, несколько кассиров и понятная аналитика.',
      register: 'Зарегистрироваться',
      haveAccount: 'У меня есть аккаунт',
      browser: 'Работает в браузере',
      devices: 'Телефон, планшет, ПК',
      fastStart: 'Старт за 5 минут',
      featuresTitle: 'Всё, что нужно магазину',
      featuresText: 'Без сложных настроек — зарегистрировались и продаёте',
      modesTitle: 'Два режима кассы',
      modesText: 'Выбирайте, как продавать — и меняйте решение в любой момент в админке',
      catalog: 'По товарам',
      quick: 'Быстрая продажа',
      withStock: 'Со складом',
      withoutStock: 'Без склада',
      catalogDescription: 'Полноценная касса для магазина с остатками',
      quickDescription: 'Для старта без товарного справочника',
      modesNote: 'Не хотите заводить товары сразу — начните с быстрой продажи, а склад подключите позже',
      audienceTitle: 'Для кого Sauda',
      audienceText: 'Небольшие точки продаж, где важна скорость и простота',
      miniMarket: 'Мини-маркет',
      cafe: 'Кафе',
      fastFood: 'Фастфуд',
      cornerShop: 'Магазин у дома',
      stepsTitle: 'Как начать',
      stepsText: 'Три шага до первой продажи',
      stepRegister: 'Зарегистрируйтесь',
      stepChoose: 'Выберите режим в админке',
      stepSell: 'Продавайте',
      blogTitle: 'Польза и советы',
      blogText: 'Короткие статьи о кассе, учёте и первых продажах',
      allArticles: 'Все статьи',
      read: 'Читать',
      minutes: 'мин',
      ctaTitle: 'Попробуйте Sauda уже сегодня',
      ctaText: 'Регистрация занимает пару минут — сразу можно продавать',
      freeStart: 'Начать бесплатно',
      footer: 'касса и учёт для малого бизнеса',
    },
  },
}
